<template>
  <v-card style="position:relative;">
    <v-img :src="item.image" aspect-ratio="2" lazy-src></v-img>
    <span class="discount">
      <h2>-{{ item.discount }}%</h2>
    </span>
    <template v-if="edit">
      <offer-edit-form ref="editForm">
        <v-layout row wrap>
          <v-flex xs12 sm6>
            <v-btn
              block
              flat
              color="primary"
              :loading="editing"
              @click="saveEditedOffer"
              >Guardar</v-btn
            >
          </v-flex>
          <v-flex xs12 sm6>
            <v-btn block flat @click="edit = false">Cancelar</v-btn>
          </v-flex>
        </v-layout>
      </offer-edit-form>
    </template>
    <template v-else>
      <offer-template :item="item" ref="offerTemplate">
        <v-layout row wrap>
          <v-flex xs12 sm4>
            <v-btn
              block
              flat
              color="primary"
              @click="publish"
              :loading="publishing"
              :disabled="item.active"
              >Publicar</v-btn
            >
          </v-flex>
          <v-flex xs12 sm4>
            <v-btn block flat @click="editOffer" :disabled="item.active"
              >Editar</v-btn
            >
          </v-flex>
          <v-flex xs12 sm4>
            <v-btn block flat :loading="deleting" @click="deleteItem"
              >Eliminar</v-btn
            >
          </v-flex>
        </v-layout>
      </offer-template>
    </template>
  </v-card>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      publishing: false,
      deleting: false,
      editing: false,
      edit: false
    }
  },
  components: {
    OfferTemplate: () => import('@/components/providers/offers/OfferTemplate'),
    OfferEditForm: () => import('@/components/providers/offers/OfferEditForm')
  },
  methods: {
    updateRemaining() {
      this.$refs.offerTemplate.updateRemaining()
    },
    async publish() {
      this.publishing = true
      await this.$store.dispatch('offers/publishOffer', { id: this.item.id })
      this.publishing = false
    },
    async deleteItem() {
      this.deleting = true
      const deleted = await this.$store.dispatch('offers/deleteOffer', {
        id: this.item.id
      })
      if (deleted) {
        this.$emit('close')
        this.$store.commit('offers/deleteOffer', { id: this.item.id })
      }
      this.deleting = false
    },
    editOffer() {
      this.edit = true
      setTimeout(() => {
        const r = this.$refs.editForm
        r.id = this.item.id
        r.title = this.item.title
        r.description = this.item.description
        r.expires_at = this.item.expires
      }, 100)
    },
    async saveEditedOffer() {
      const r = this.$refs.editForm
      const data = {
        id: r.id,
        offer: {
          title: r.title,
          description: r.description,
          expires_at: r.expires_at
        }
      }
      this.editing = true
      const edited = await this.$store.dispatch('offers/editOffer', data)
      if (edited.ok) this.edit = false
      this.editing = false
    }
  }
}
</script>
<style scoped>
.discount {
  background-color: red;
  color: white;
  display: inline-block;
  padding: 4px 10px;
  position: absolute;
  top: 30px;
  right: 0;
}
.discount h2 {
  font-weight: 900;
}
</style>